// extracted by mini-css-extract-plugin
export default {"container":"Comment_container__PLbMF","author":"Comment_author__Q6DUf","imageContainer":"Comment_imageContainer__t6EX-","content":"Comment_content__qZxGf"};